import React, { useEffect, useState } from "react";
import axios from "axios";
import { localURL } from "./../../utils/serverURL";
import { BsStarFill } from "react-icons/bs";
import { BsStarHalf } from "react-icons/bs";

const ExperienceRating = ({ experienceId }) => {
  const [experienceRating, setExperienceRating] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.post(`${localURL}experiences/avgRating`, {
          experienceId: experienceId,
        });
        setExperienceRating(response.data.message[0].avgRating);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);
  const floorValue = Math.floor(experienceRating);
  const difference = experienceRating - floorValue;
  const remaining = 5 - Math.ceil(experienceRating);

  return (
    <div className="text-red-600 text-base font-bold flex justify-start items-start  w-full gap-1 my-2 ">
      {floorValue
        ? new Array(floorValue).fill(0).map(() => <BsStarFill />)
        : null}

      {difference ? <BsStarHalf /> : null}

      {remaining
        ? new Array(remaining)
            .fill(0)
            .map(() => <BsStarFill className="text-gray-700" />)
        : null}

      <span className="ml-2">{experienceRating ? experienceRating : null}</span>
    </div>
  );
};

export default ExperienceRating;
